
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Col, Container, Form, Image, InputGroup, Row, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import Thumb from './common/Thumb';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import { arrayShuffle, imageUrl, imgPath } from '../service/CommonUtil';
import { Tab, Tabs } from '@mui/material';
import CommonDialog from './common/CommonDialog';
import TaggedImageSlider from './common/TaggedImageSlider';
import Gallery from './common/Gallery';

const Random = () => {
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImage(page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/random/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()

    useEffect(() => {
        if(loginInfo.result){
            // ユーザ設定
            getUserSetting().then(r => {
                if(r.result){
                    setUserSetting(r.data)
                }
            })
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    const [imageList,setImageList] = useState([])
    const [userSetting, setUserSetting] = useState([]);
    const [followUserImage,setFollowUserImage] = useState([...Array(0)])
    const [imagePage,setImagePage] = useState(1)
    const [loading,setLoading] = useState(true)

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 1000 - 1) ){
                    setImagePage(imagePage+1)
                }
              }
        })
    }, options);

    useEffect(() => {
        getImage(imagePage).then(r => {
            if(r.result){
                if(r.data.length > 0){
                    setImageList(imageList.concat(arrayShuffle(r.data)))
                } else {
                    if(imagePage === 1){
                        dialog("","まだ投稿がありません。1枚目を投稿しませんか？")
                    }
                }
            }
            setLoading(false)
        })
    },[imagePage])

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "作品を発見 - アワートAI"
    },[])

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const [showSetting,setShowSetting] = useState(false)

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList,followUserImage])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }
    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <CommonDialog open={show}
            content={dialogMessage}
            onClick={() => {
                setShow(false)
            }} onClose={() => setShow(false)}
            title={dialogTitle} />
        <Header />
        <Category />
        <div className='p-0' style={{position:"fixed",zIndex:2,width:"100%",top:"68px",backgroundColor:"inherit",overflow:"auto"}} id="category-bar">
            <div className='mt-1 mb-1' style={{width:"900px",fontSize:"24px",fontWeight:"bold",backgroundColor:"inherit"}}>
                <Tabs variant='fullWidth' value="random" onChange={(e) => {
                    switch(e.target.tabIndex){
                        case 0:
                            navigate("/")
                        break
                        case 1:
                            navigate("/new")
                        break
                        case 2:
                            navigate("/osusume")
                        break
                        case 3:
                            navigate("/ranking")
                        break
                        case 4:
                            navigate("/random")
                        break
                        case 5:
                            navigate("/newFollow")
                        break
                        case 6:
                            navigate("/newUser")
                        break
                        case 7:
                            navigate("/attention")
                        break
                    }
                    }} centered>
                    <Tab label={"Top"} value="0" tabIndex={0}></Tab>
                    <Tab label={t("home.new")} value="new" tabIndex={1} onClick={() => navigate("/new")}></Tab>
                    <Tab label={t("osusume.title")} value="osusume" tabIndex={2}></Tab>
                    <Tab label={t("category.ranking")} value="ranking" tabIndex={3}></Tab>
                    <Tab label={"注目"} value="attention" tabIndex={7}></Tab>
                    <Tab label={t("category.discover")} value="random" tabIndex={4}></Tab>
                    <Tab label={t("newFollow.title")} value="newFollow" tabIndex={5}></Tab>
                    <Tab label={t("newUser.title")} value="newUser" tabIndex={6}></Tab>
                    <Icon.GearFill
                        onClick={() => setShowSetting(!showSetting)}
                        style={{fontSize:"32px",marginLeft:"10px",marginRight:"10px",cursor:"pointer"}} />
                </Tabs>
            </div>
        </div>
        <Container style={{position:"fixed",top:"127px",zIndex:2,backgroundColor:"#FFFFFF",display:showSetting ? "block" : "none",width:"auto"}} className='p-0'>
            <Row>
                <Col xs={8} sm={8} md={7} lg={7} xl={7} xxl={7} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onClick={(e) => {
                            updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setOmitContinuous(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                    </InputGroup>
                </Col>
                <Col xs={8} sm={8} md={5} lg={5} xl={5} xxl={5} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onClick={(e) => {
                            updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setTileMode(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.tileMode")} readOnly />
                    </InputGroup>
                </Col>
            </Row>
        </Container>
        <div style={{marginTop:"140px"}}>
            <TaggedImageSlider />
        </div>
        {loading ? <Spinner animation="border" size="lg" style={{marginTop:"60px"}} /> : ""}
        {
            /**
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                style={{marginTop:"220px"}}
                >
                {imageList.map((data,i) => {
                    if(data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                        return <span data-no={i} className="lazy" key={i}></span>
                    }
                return <Tile data={data} i={i} dialog={dialog} key={i} observer={observer} list={imageList} listName={t(("category.discover"))} />

                })}
            </Masonry>
             */
        }
        {tileMode ? (<div>
            <Gallery images={imageList.map(d => {
                d.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath("image") + '/post/t/'+(d.id)+"_m"+ApiFetch.API_THUMB_EXT
                d.aspect = d.width/d.height
                return d
            }).map((d,i) => {
                if(d.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)
                // 全年齢作品はセーフチェックに引っかかった場合は非表示
                || (d.age_limit === 1 && userSetting?.r15_display_flag === 2 && userSetting?.r18_display_flag === 2 && userSetting?.r18g_display_flag === 2 && d.is_safe === 0)
                ){
                    d.isMute = true
                } else {
                    d.isMute = false
                }
                return d
            })} dialog={dialog} /></div>
        ) : (
        <div className='d-flex flex-row justify-content-start flex-wrap w-100' style={{marginTop:"220px"}}>
            {imageList.map((data,i) => {
                if(data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)
                // 全年齢作品はセーフチェックに引っかかった場合は非表示
                || (data.age_limit === 1 && userSetting?.r15_display_flag === 2 && userSetting?.r18_display_flag === 2 && userSetting?.r18g_display_flag === 2 && data.is_safe === 0)
                ){
                    return <span data-no={i} className="lazy" key={i}></span>
                }
            return <Thumb data={data} i={i} dialog={dialog} key={i} observer={observer} />
            })}
        </div>
        )}
        <Footer />
    </div>
    )
}

export default Random;
